<ng-container *ngIf="value; else falseTmp">
  <i class="{{ iconStyle }} {{ trueIcon }}"></i>
  <ng-content select="[true]"></ng-content>
</ng-container>
<ng-template #falseTmp>
  <i class="{{ iconStyle }} {{ falseIcon }}"></i>
  <ng-content select="[false]"></ng-content>
</ng-template>
